import React, { useState } from 'react'
import InputRow from '../elements/InputRow'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'

const ManualInput = (props) => {
    const [formData, setFormData] = useState({
        unitNumber: '',
        streetNumber: '',
        streetName: '',
        streetType: '',
        suburb: '',
        postcode: '',
        state: ''
    })
    const [formError, setFormError] = useState({
        streetNumberError: '',
        streetNameError: '',
        streetTypeError: '',
        suburbError: '',
        postcodeError: '',
        stateError: ''
    })

    const handleSubmit = (e) => {
        e.preventDefault()
        const { unitNumber, streetNumber, streetName, streetType, suburb, postcode, state } = formData
        const unit = unitNumber !== '' ? 'Unit ' + unitNumber : ''

        const formDataCheck = {
            ...formData
        }
        delete formDataCheck.unitNumber

        let tempFormError = {
            streetNumberError: '',
            streetNameError: '',
            streetTypeError: '',
            suburbError: '',
            postcodeError: '',
            stateError: ''
        }

        if (Object.values(formDataCheck).some(value => value === '')) {
            Object.keys(formDataCheck).map((item) => {
                if (formDataCheck[item] === '') {
                    tempFormError = {
                        ...tempFormError,
                        [item + 'Error']: `Please ${transformName(item)}`
                    }
                }
            })
            setFormError(...formError, tempFormError)
        } else if (isNaN(formDataCheck.postcode)  || formDataCheck.postcode.length < 4) {
            const error  = { ...tempFormError,
                postcodeError: 'Please enter a valid postcode'
            }
            setFormError(error)
        } else  {
            const address = unit + ' ' + streetNumber + ' ' + streetName + ' ' + streetType.streetType + ', ' + suburb + ' ' + state.state + ' ' + postcode
            props.setAddress(address)
            props.handleHideManualSearch(e)
            props.clearAddressList()
        }
    }

    const transformName = (item) => {
        if (item === 'streetNumber') {
            return 'enter street number'
        } else if (item === 'streetName') {
            return 'enter street name'
        } else if (item === 'streetType') {
            return 'enter street type'
        } else if (item === 'state') {
            return 'select state'
        } else {
            return 'enter ' + item
        }
    }

    const handleChange = (e) => {
        setFormError({
            ...formError,
            [e.target.name + 'Error']: ''
        })
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleStreetTypeSelect = (value) => {
        setFormError({
            ...formError,
            streetTypeError: ''
        })
        setFormData({
            ...formData,
            streetType: value
        })
    }

    const handleStateSelect = (value) => {
        setFormError({
            ...formError,
            stateError: ''
        })
        setFormData({
            ...formData,
            state: value
        })
    }

    const mapListToArray = (list) => {
        const data = []
        list.forEach(item => {
            data.push({ label: item, value: item })
        })
        return data
    }

    const Close = (
        <div className='close-no-address d-flex' onClick={e => props.handleHideManualSearch(e)}><img src='/images/icon-close.svg' />
            <p className='m-0 color-light-grey font-tiny'>Close search</p>
        </div>
    )

    return (
        <div className='manual-input-container address-list p-3'>
            <div className='d-flex sub-bold justify-content-between align-items-center'>
                <p className='m-0 font-smaller'>Manually enter your address below:</p>
                {Close}
            </div>
            <form className='mt-3 manual-input-form'>
                <div className='row'>
                    <div className='col-12 col-lg-6'>
                        <p className='font-small sub-bold m-0 mb-2'>Unit number: (Optional) </p>
                        <InputRow
                            name='unitNumber'
                            value={formData.unitNumber}
                            handleChange={e => handleChange(e)}
                            placeholder=''
                            hideLabel
                        />
                    </div>
                    <div className='col-12 col-lg-6'>
                        <p className='font-small sub-bold m-0 mb-2'>Street number: </p>
                        <InputRow
                            name='streetNumber'
                            value={formData.streetNumber}
                            handleChange={e => handleChange(e)}
                            errors={formError.streetNumberError}
                            placeholder=''
                            hideLabel
                        />
                    </div>
                    <div className='col-12 col-lg-6'>
                        <p className='font-small sub-bold m-0 mb-2'>Street name: </p>
                        <InputRow
                            name='streetName'
                            value={formData.streetName}
                            handleChange={e => handleChange(e)}
                            errors={formError.streetNameError}
                            placeholder=''
                            hideLabel
                        />
                    </div>
                    <div className='col-12 col-lg-6'>
                        <p className='font-small sub-bold m-0 mb-2'>Street type: </p>
                        <FancySelectAdvancedRow
                            className='select-no-label'
                            options={mapListToArray(streetTypeList)}
                            value={formData.streetType}
                            placeholder='Street, Place etc...'
                            label=''
                            name='streetType'
                            handleChange={(value) => handleStreetTypeSelect(value)}
                            errors={formError.streetTypeError}
                        />
                    </div>
                    <div className='col-12 col-lg-6'>
                        <p className='font-small sub-bold m-0 mb-2'>Suburb: </p>
                        <InputRow
                            name='suburb'
                            value={formData.suburb}
                            handleChange={e => handleChange(e)}
                            errors={formError.suburbError}
                            placeholder=''
                            hideLabel
                        />
                    </div>
                    <div className='col-6 col-lg-3'>
                        <p className='font-small sub-bold m-0 mb-2'>Postcode: </p>
                        <InputRow
                            name='postcode'
                            value={formData.postcode}
                            handleChange={e => handleChange(e)}
                            errors={formError.postcodeError}
                            placeholder=''
                            hideLabel
                        />
                    </div>
                    <div className='col-6 col-lg-3'>
                        <p className='font-small sub-bold m-0 mb-2'>State: </p>
                        <FancySelectAdvancedRow
                            className='select-no-label'
                            options={mapListToArray(state)}
                            value={formData.streetType}
                            placeholder='NSW, ACT...'
                            label=''
                            name='state'
                            handleChange={(value) => handleStateSelect(value)}
                            errors={formError.stateError}
                        />
                    </div>
                    <div className='col-12 text-right mt-2'>
                        <button className='p-3 px-5 mb-3 font-large do-animate-rollover btn btn-custom search-btn' type='submit' onClick={handleSubmit}>Manual Search</button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default ManualInput

const state = ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT']

const streetTypeList = [
    'St',
    'Rd',
    'Pl',
    'Dr',
    'Ct',
    'Ave',
    'Bvd',
    'Gr',
    'Hwy',
    'Ally',
    'Arc',
    'Bypa',
    'Cct',
    'Cl',
    'Crn',
    'Cres',
    'Cds',
    'Esp',
    'Grn',
    'Jnc',
    'Lane',
    'Link',
    'Mews',
    'Pde',
    'Rdge',
    'Sq',
    'Tce'
]



// WEBPACK FOOTER //
// ./resources/js/components/ManualInput.js